// Bridges ui.ts's cast handler to GameScene for a Bind·Energy cast -- opens a
// thermal-contact link between the faced object and the marked Source (or the
// caster, if nothing is marked). The actual equilibration isn't triggered
// from here: it lives in rune-lab/src/sim/energyBind.ts's settleEnergyBind,
// run every settle from inside applyEnergyBindEffect itself and from every
// other settle-triggering cast afterward. See EnergyBindDef in
// rune-lab/src/sim/types.ts for the full mechanic.
//
// The event/result shapes themselves live in rune-lab/src/sim/casts.ts with the
// handler that consumes them, and are re-exported here unchanged, so every
// import site reads them from this module -- the same shape every other
// operator effect's bridge already has.
import { EnergyBindEffectEvent, EnergyBindEffectResult } from '../../rune-lab/src/sim/casts';

export type { EnergyBindEffectEvent, EnergyBindEffectResult };

type Handler = (event: EnergyBindEffectEvent) => EnergyBindEffectResult;

let handler: Handler | null = null;

export function onEnergyBindEffect(fn: Handler): void {
  handler = fn;
}

export function triggerEnergyBindEffect(event: EnergyBindEffectEvent): EnergyBindEffectResult {
  return handler ? handler(event) : { applied: false, targetName: '', sourceWasSelf: true };
}
